import { bytesToKilobytes } from "../utility/bytesToKilobytes";
import { generateHeading } from "./generateHeading";
import { removeResultStatusNotUsed } from "./removeResultStatusNotUsed"

export function renderSearchResultsBasisinformationblaetter({ resultList, selectedResult, target, title }) {
  try {
    const filteredList = resultList.filter(res => {
      return res.title.includes(selectedResult.hidden_content.WKN)
    })

    const searchResultContainer = document.querySelector(`.fonds_brochures_result_target[data-for="${target}"]`)

    if (!searchResultContainer) {
      console.warn(`Can't render search result. No search result container found with "data-for=${target}" attribute.`)
      return
    }

    /**
     * for displaying the search result we need the following data:
     * description
     * file link
     * file size
     * year from the directory path
     */

    searchResultContainer.innerHTML = ''

    // generate heading tag
    searchResultContainer.appendChild(generateHeading(title))

    // removing the result status unused string
    removeResultStatusNotUsed()

    // creating the table

    // 1. table base and table head
    const tableWrapper = document.createElement('div')
    tableWrapper.classList.add('tablesaw-overflow')
    searchResultContainer.appendChild(tableWrapper)

    const table = document.createElement('table')
    table.classList.add('table')
    tableWrapper.appendChild(table)

    const thead = document.createElement('thead')
    table.appendChild(thead)
    const theadRow = document.createElement('tr')

    const thData = ['Datum', 'Beschreibung', 'Details']
    thData.forEach(content => {
      const th = document.createElement('th')

      if (content === thData[2]) {
        th.classList.add('right')
      }
      th.innerText = content
      theadRow.appendChild(th)
    })

    thead.appendChild(theadRow)

    const tbody = document.createElement('tbody')
    table.appendChild(tbody)

    filteredList.sort((a, b) => {
      return getDataFromFilename(b.title).dateRaw.getTime() - getDataFromFilename(a.title).dateRaw.getTime()
    }).forEach(result => {
      try {
        /*
        Example structure:
        <tr>
            <td>
              <a class="d-block" href="/fileadmin/Ausschuettungen_Thesaurierungen/2022/LBBW_Multi_Global_I.pdf">2022</a>
            </td>
            <td>WKN A1H725, Ausschüttung per 16.03.2022</td>
            <td class="right">
              <a class="d-block" href="/fileadmin/Ausschuettungen_Thesaurierungen/2022/LBBW_Multi_Global_I.pdf" target="_blank">PDF <span>(80 kb)</span></a>
            </td>
        </tr>
      */
        const tr = document.createElement('tr')
        tbody.appendChild(tr)

        const yearColumn = document.createElement('td')
        const yearLink = document.createElement('a')
        yearLink.href = result.path
        yearLink.target = '_blank'
        yearLink.classList.add('d-block')
        /**
         * @type {string[]}
         */
        yearLink.innerText = getDataFromFilename(result.title).date
        yearColumn.appendChild(yearLink)
        tr.appendChild(yearColumn)

        const descriptionColumn = document.createElement('td')
        descriptionColumn.innerText = "Kostenstruktur zum Basisinformationsblatt"
        tr.appendChild(descriptionColumn)

        const detailsColumn = document.createElement('td')
        detailsColumn.classList.add('right')
        const detailsLink = document.createElement('a')
        detailsLink.href = result.path
        detailsLink.target = '_blank'
        detailsLink.innerText = 'PDF'
        detailsColumn.appendChild(detailsLink)
        const filesize = document.createElement('span')
        const sizeInKb = bytesToKilobytes(Number(result.hidden_content['file size'].replace(' bytes', ''))).toFixed(2)
        filesize.innerText = ` (${sizeInKb} kb)`
        detailsColumn.appendChild(filesize)
        tr.appendChild(detailsColumn)
      } catch (error) {
        console.error(error)
      }
    })

  } catch (error) {
    console.error(error)
  }
}

function getDataFromFilename(filename = 'kostenstruktur_priip_976688_20230123.pdf') {
  try {
    const [rest, filetype] = filename.split('.')
    const [type, priip, WKN, dateString] = rest.split('_')

    const year = parseInt(dateString.slice(0, 4), 10);
    const month = parseInt(dateString.slice(4, 6), 10) - 1; // Month is zero-based in JS Date
    const day = parseInt(dateString.slice(6, 8), 10);

    const date = new Date(year, month, day)

    return {
      filetype,
      type,
      priip,
      WKN,
      dateRaw: date,
      date: `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`,
    }
  } catch (error) {
    console.error(`Filename "${filename}" is invalid, can't find a date.`, error)
  }
  return {}
}